'use client'

import { TableSize } from '@/components/common/table-size'
import { BODY_SIZE } from '../../../../../lib/constants/size'

export const BodyInfo = () => {
  const bodyInfo = BODY_SIZE
  return (
    <>
      <p className='mb-2 text-sm text-neutral-600'>
        *Các số đo chỉ mang tính chất tham khảo tùy theo vóc dáng và sở thích
        mặc của bạn.
      </p>
      <TableSize
        rows={bodyInfo.rows}
        columns={bodyInfo.columns}
        matrix={bodyInfo.matrix}
        colClassName='min-w-32 text-start'
      />
    </>
  )
}
